import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { ReactSwitch } from "../../components/switches/dropdown-section";

import "../../styles/auth.css";
import "../../styles/profile.css";
import { AppAlert } from "../../components/utilities/alert";
import { useAuth } from "../../services/authentication/authentication.context";
import { Loader } from "../../components/utilities/loader";

export const UserUpdate = () => {

    const { addAsadmin, isLoading, token } = useAuth();

    const userData = useLocation().state?.account;

    const [isAdmin, setIsAdmin] = useState(false);
    const [onAlert, setOnAlert] = useState();
    

    useEffect(() => {
        userData?.role === "user" ? setIsAdmin(false) : setIsAdmin(true);
    },[userData])
    

    const toggleSwitch = () => {
        setIsAdmin((s) => !s);
        addAdmin(token, userData?.email);
        setOnAlert();
    };


    const addAdmin = async (token, email) => {
        const res = await addAsadmin(token, email);
        if (res?.error){
            alert(res?.error);
            return;
        }
        setOnAlert({
            caption: "Success",
            message: `${res?.names}'s role has been changed to ${res?.role}`,
            accept: "OK",
            acceptAction: () => setOnAlert()
        })
    }


    return (
        <div>
            <BmsHeader />
            <SkewBox title={"Update user: "+ userData?.names} />
            {isLoading  && <Loader />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    acceptAction={onAlert.acceptAction}
                    rejectAction={() => setOnAlert()}
                    message={onAlert.message}
                    close={()=> setOnAlert()}
                />
            )}
            <div className="notes-page">
                <div className="form-container">
                    <div style={{display: "flex", alignItems: "center"}}>
                        <strong>
                            {isAdmin ? "Admin": "User"}
                        </strong>
                        <ReactSwitch
                            switchedColor={"#2d4a5f"}
                            unswitchedColor={'#dedede'}
                            onSwitch={() => {
                                setOnAlert({
                                    caption: "Change user role!",
                                    message: `Do you wish to change ${userData?.names}'s role?`,
                                    accept:"Yes",
                                    reject: "Cancel",
                                    acceptAction:() => toggleSwitch(),
                                })
                            }}
                            switched={isAdmin}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}